import { render, staticRenderFns } from "./SubNavCard.vue?vue&type=template&id=a1230b76"
import script from "./SubNavCard.vue?vue&type=script&lang=js"
export * from "./SubNavCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports